import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { getTestLabels } from '../../../../utils/getTestLabels.js';
import style from '../../DropdownMenu/DropdownMenu.module.scss.js';

const { componentTestLabel } = getTestLabels('Backdrop');
/**
 * @param {number | string} zIndex - (optional) Use this to override the default CSS `z-index` property of the dropdown menu (defaults to `100`).
 */
const Backdrop = (props) => {
    const { children, className, zIndex = 100, ...otherProps } = props;
    return (jsx("div", { "data-zta": componentTestLabel, className: classNames(className, style['z-dropdown-menu__backdrop']), style: { zIndex }, ...otherProps, children: children }));
};
Backdrop.displayName = 'Backdrop';

export { Backdrop };
//# sourceMappingURL=Backdrop.js.map
